import { CollapsibleView } from "./CollapsibleView";

export default CollapsibleView;
